import styled from 'styled-components';
import { ButtonProps } from '../types';

export const StyledButton = styled.button.attrs<ButtonProps>({})<ButtonProps>`
	&&& {
		${(props) => props.rounded && `border-radius: 150px;`}
		display: flex;
		text-align: center;
		flex-direction: ${(props) =>
			props.contentOrder === 'reverse' ? 'row-reverse' : 'row'};
		justify-content: center;
		font-weight: 700;
		font-size: ${({ size }) =>
			size === 'sm' ? '0.9rem' : size === 'md' ? '1rem' : '1.2rem'};
		padding: ${({ size }) =>
			size === 'sm' ? '8px 12px' : size === 'md' ? '12px 24px' : '16px 32px'};
		&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(
				.border-active
			):not(.btn-flush):not(.btn-icon) {
			padding: ${({ size }) =>
				size === 'sm' ? '8px 12px' : size === 'md' ? '12px 24px' : '16px 32px'};
		}

		:not([disabled]):hover {
			color: ${({ disabled }) => (disabled ? '' : '#fff')};
			cursor: ${({ disabled }) => (disabled ? '' : 'pointer')};
		}
	}
`;

export const StyledText = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: #5e6278;
`;
